export const sortParams = ['alphabetical', 'recently_created', 'recently_edited', 'view_count'] as const;

type SortParam = (typeof sortParams)[number];
export default SortParam;

export const SORT_PARAM_KEY_LOCAL_STORAGE = 'workspace-sort-param';
export const defaultSortParam: SortParam = 'recently_edited';

export const labels: Record<SortParam, string> = {
  alphabetical: 'Alphabetical',
  recently_created: 'Recently Created',
  recently_edited: 'Recently Edited',
  view_count: 'View Count'
};
